import i18n from "../../../i18n"
import { required, same, validateError } from "../../../utils/validate"
import { useForm as createUseForm } from "@ant-design-vue/use";
import { setIsLoading as setIsLoadingApp } from '../../../app.logic'
import store from '../../../store'
import { Input } from 'ant-design-vue'

export const callMeChangePassword = ({ form }) => store.dispatch(`resource/v1/security/user/meChangePassword`, { data: { oldPassword: form.presentPassword, newPassword: form.newPassword } })

export const onClickChangePassword = ({ data }) => {
    return data.useForm
        .validate()
        .then(() => {
            setIsLoadingApp(true)
            return callMeChangePassword({ form: data.useForm.modelRef })
                .finally(() => setIsLoadingApp(false))
        })
        .catch((error) => {
            validateError({ error })
            throw error
        });
}

export const createForm = () => {
    return {
        presentPassword: null,
        newPassword: null,
        confirmPassword: null,
    }
}

export const createRules = ({ data }) => {
    return {
        presentPassword: [required],
        newPassword: [required],
        confirmPassword: [required, same(data.form, 'newPassword', i18n.global.t('views.changePassword.newPassword'), i18n.global.t('views.changePassword.confirmPassword'))],
    }
}

export const createField = ({ data }) => {
    const dirty = {}
    const { useForm } = data
    const { modelRef } = useForm
    return [
        {
            key: 'presentPassword',
            visible: () => true,
            colProp: () => ({ xs: 24 }),
            formItemProp: () => ({ labelCol: { xs: 24, md: 9 }, wrapperCol: { xs: 24, md: 15 } }),
            inputRender: ({ field }) => {
                const placeholder = field.label()
                return <Input.Password value={modelRef.presentPassword} onUpdate:value={value => modelRef.presentPassword = value} placeholder={placeholder}></Input.Password>
            },
            label: () => i18n.global.t('views.changePassword.presentPassword'),
        },
        {
            key: 'newPassword',
            visible: () => true,
            colProp: () => ({ xs: 24 }),
            formItemProp: () => ({ labelCol: { xs: 24, md: 9 }, wrapperCol: { xs: 24, md: 15 } }),
            inputRender: ({ field }) => {
                const placeholder = field.label()
                const onBlur = () => {
                    if (dirty['confirmPassword']) {
                        useForm.validate('confirmPassword').catch(() => { })
                    }
                    useForm.validate('newPassword').catch(() => { })
                }
                return <Input.Password value={modelRef.newPassword} onUpdate:value={value => modelRef.newPassword = value} onBlur={onBlur} placeholder={placeholder}></Input.Password>
            },
            label: () => i18n.global.t('views.changePassword.newPassword'),
        },
        {
            key: 'confirmPassword',
            visible: () => true,
            colProp: () => ({ xs: 24 }),
            formItemProp: () => ({ labelCol: { xs: 24, md: 9 }, wrapperCol: { xs: 24, md: 15 } }),
            inputRender: ({ field }) => {
                const placeholder = field.label()
                const onBlur = () => {
                    dirty['confirmPassword'] = true
                    useForm.validate('confirmPassword').catch(() => { })
                }
                return <Input.Password value={modelRef.confirmPassword} onUpdate:value={value => modelRef.confirmPassword = value} onBlur={onBlur} placeholder={placeholder}></Input.Password>
            },
            label: () => i18n.global.t('views.changePassword.confirmPassword'),
        },
    ]
}

export const initForm = ({ props, data, refs }) => {
    data.form = createForm({ props, data, refs });
    data.rules = createRules({ props, data, refs });
    data.useForm = createUseForm(data.form, data.rules);
    data.fields = createField({ props, data, refs });
}
